import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledLegend from './StyledLegend';
import StyledLegendItem from './StyledLegendItem';

const Legend = ({items = [], renderItem = null, title = null, horizontal = false, className = null}) => {
	const renderLegend = (item, i) => (
		<StyledLegendItem key={i} $color={item.color}>
			{renderItem && renderItem(item)}
		</StyledLegendItem>
	);

	const props = {
		className: classNames('legend', {[`${className}`]: !!className, horizontal})
	};

	return (
		<StyledLegend {...props}>
			{title && <OutputText body2>{title}</OutputText>}
			<div className="items">{items.map(renderLegend)}</div>
		</StyledLegend>
	);
};

Legend.propTypes = {
	title: PropTypes.string,
	renderItem: PropTypes.func,
	items: PropTypes.array,
	horizontal: PropTypes.bool,
	className: PropTypes.string
};

export default Legend;
